// The inferred-region tables (plan 2026-10-04, section 3): IANA time zones,
// ISO 3166-1 region codes and store ids. Not user-facing text. Kept in a
// *.codes.ts file, which the literal guard (eslint.i18n.config.js) skips by
// design, because the rule cannot tell a code from prose. The logic that
// reads them is region.ts.
import type { RegionalStoreId } from '../api/stores'

/** IANA zone -> ISO region, EXACT match only. Europe/Mariehamn (Aland)
 *  reports FI, the member state, which is what the iOS allowlist carries. */
export const ZONE_REGION = new Map<string, string>([
  // Hareruya
  ['Asia/Tokyo', 'JP'],
  // LigaMagic
  ['America/Sao_Paulo', 'BR'],
  ['America/Bahia', 'BR'],
  ['America/Fortaleza', 'BR'],
  ['America/Recife', 'BR'],
  ['America/Maceio', 'BR'],
  ['America/Araguaina', 'BR'],
  ['America/Belem', 'BR'],
  ['America/Santarem', 'BR'],
  ['America/Manaus', 'BR'],
  ['America/Boa_Vista', 'BR'],
  ['America/Porto_Velho', 'BR'],
  ['America/Cuiaba', 'BR'],
  ['America/Campo_Grande', 'BR'],
  ['America/Rio_Branco', 'BR'],
  ['America/Eirunepe', 'BR'],
  ['America/Noronha', 'BR'],
  // Cardmarket: the EU, the EEA, GB and CH
  ['Europe/Vienna', 'AT'],
  ['Europe/Brussels', 'BE'],
  ['Europe/Sofia', 'BG'],
  ['Europe/Zagreb', 'HR'],
  ['Asia/Nicosia', 'CY'],
  ['Asia/Famagusta', 'CY'],
  ['Europe/Nicosia', 'CY'],
  ['Europe/Prague', 'CZ'],
  ['Europe/Copenhagen', 'DK'],
  ['Europe/Tallinn', 'EE'],
  ['Europe/Helsinki', 'FI'],
  ['Europe/Mariehamn', 'FI'],
  ['Europe/Paris', 'FR'],
  ['Europe/Berlin', 'DE'],
  ['Europe/Busingen', 'DE'],
  ['Europe/Athens', 'GR'],
  ['Europe/Budapest', 'HU'],
  ['Europe/Dublin', 'IE'],
  ['Europe/Rome', 'IT'],
  ['Europe/Riga', 'LV'],
  ['Europe/Vilnius', 'LT'],
  ['Europe/Luxembourg', 'LU'],
  ['Europe/Malta', 'MT'],
  ['Europe/Amsterdam', 'NL'],
  ['Europe/Warsaw', 'PL'],
  ['Europe/Lisbon', 'PT'],
  ['Atlantic/Madeira', 'PT'],
  ['Atlantic/Azores', 'PT'],
  ['Europe/Bucharest', 'RO'],
  ['Europe/Bratislava', 'SK'],
  ['Europe/Ljubljana', 'SI'],
  ['Europe/Madrid', 'ES'],
  ['Africa/Ceuta', 'ES'],
  ['Atlantic/Canary', 'ES'],
  ['Europe/Stockholm', 'SE'],
  ['Atlantic/Reykjavik', 'IS'],
  ['Europe/Vaduz', 'LI'],
  ['Europe/Oslo', 'NO'],
  ['Europe/London', 'GB'],
  ['Europe/Zurich', 'CH'],
])

/** The store each region code maps to. Exactly the iOS ISO allowlist. */
export const REGION_STORE = new Map<string, RegionalStoreId>([
  ['JP', 'hareruya'],
  ['BR', 'ligamagic'],
  ...[
    // EU
    'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT',
    'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE',
    // EEA
    'IS', 'LI', 'NO',
    // plus
    'GB', 'CH',
  ].map(code => [code, 'cardmarket'] as [string, RegionalStoreId]),
])
